import { render, staticRenderFns } from "./DownloadFulfillmentOrders.vue?vue&type=template&id=059f2787"
import script from "./DownloadFulfillmentOrders.vue?vue&type=script&lang=js"
export * from "./DownloadFulfillmentOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports